import type { ComponentType } from 'react'
import { Tooltip } from '../../../../core'
import type { components } from '@joyful/openapi/types.gen'
import { createEnumSchema } from '@joyful/utils'
import type { EnumValueMeta } from '@joyful/utils'
import { BotIcon, BuildingIcon, UserIcon } from 'lucide-react'

interface PracticeRequestOwnerMetadata extends EnumValueMeta {
  description: string
  icon: ComponentType<React.SVGProps<SVGSVGElement>>
}

export const PracticeRequestOwnerSchema = createEnumSchema<
  components['schemas']['PracticeRequestOwner'],
  PracticeRequestOwnerMetadata
>([
  {
    description: `The practice currently owns this request`,
    icon: BuildingIcon,
    title: `Practice`,
    value: 'PRACTICE',
  },
  {
    description: `A Joyful agent currently owns this request`,
    icon: BotIcon,
    title: `Joyful agent`,
    value: 'JOYFUL_AGENT',
  },
  {
    description: `A Joyful human currently owns this request`,
    icon: UserIcon,
    title: `Joyful human`,
    value: 'JOYFUL_HUMAN',
  },
])

export interface PracticeRequestOwnerBadgeProps {
  owner: components['schemas']['PracticeRequestOwner']
}

export function PracticeRequestOwnerBadge({
  owner,
}: PracticeRequestOwnerBadgeProps) {
  const meta = PracticeRequestOwnerSchema.meta(owner)
  return (
    <Tooltip content={meta.description} title={meta.title}>
      <span
        aria-label={`Owner: ${meta.title}`}
        className="text-tremor-content focus-visible:ring-tremor-brand focus-visible:ring-offset-tremor-background inline-flex size-6 items-center justify-center rounded-xs outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2"
        role="img"
        tabIndex={0}
      >
        <meta.icon aria-hidden className="size-3.5" />
      </span>
    </Tooltip>
  )
}
